import { useMutation } from '@tanstack/react-query';

import type {
  DeleteOnlineServiceResponse,
  MutationResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteOnlineServiceMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; id: number }) =>
      HttpClient.request<DeleteOnlineServiceResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
  });

export const useOnlineServiceFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: {
        online_service: {
          name: string;
          description?: string;
          location_ids: number[];
          service_ids: number[];
          online_payment_key_ids: number[];
          order_position: number;
          active: boolean;
          subscription: boolean;
          start_service_id?: number | null;
          resubscribe_days?: number | null;
        };
      };
    }) =>
      HttpClient.request<MutationResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
